module.exports = __webpack_public_path__ + "img/35-800x800.f38a41ba.jpg";